import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AttachmentPreviewWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  height: 77vh;
  margin-right: ${Spacing.S12};
  border: 1px solid ${Color.Grey150};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Grey100};
`
